import React, { useMemo, useRef, useState } from "react"
import GoogleMap from "@/components/Maps/GoogleMap"
import useCurrentBranchData from "@/hooks/useCurrentBranchData"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import useGlobals from "@/hooks/useGlobals"
import { useNavigatorContext } from "@/components/BranchNavigator"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import BranchSelect from "@/components/BranchSelect"
import { ScrollTrigger, useGSAP } from "@/utils/gsap"
import { useScrollDirection } from "@/hooks/useScrollContext"

const Wrapper = styled(GridContainer)`
	min-height: ${getCssSizeValue(148, BREAKPOINTS.MOBILE)};
	z-index: 5;
`

const TranslateContainer = styled(GridContainer)`
	position: relative;
	background-color: ${({ theme }) => theme.colors.periwinkle};
	transition: translate var(--rgr-duration) var(--ease);

	&:before {
		content: "";
		position: absolute;
		inset: 0;
		background-color: white;
		//z-index: 4;
		translate: 0 -100%;
		transition: translate var(--rgr-duration) var(--ease);
	}

	&.shift {
		//translate: 0 -12.5vh;
	}
`
const MapContainer = styled.div`
	margin-right: calc(-1 * var(--paddingX));
`

const Container = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)};
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(8, BREAKPOINTS.MOBILE)} ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
`
const GMAP = ({ onClick, className = "" }) => {
	const { currentUnit } = useNavigatorContext()
	const branch = useCurrentBranchData()
	const current = useMemo(() => {
		return currentUnit?.id ? currentUnit : branch
	}, [currentUnit, branch])
	return (
		<MapContainer onClick={onClick} className={`${className}`}>
			<GoogleMap
				lat={current.geolocation?.latitude}
				lng={current.geolocation?.longitude}
				zoom={branch.handle === "global" ? 5 : 12}
				apiKey={process.env.NEXT_GOOGLE_MAP_KEY}
				markers={{
					lat: current.geolocation?.latitude,
					lng: current.geolocation?.longitude,
				}}
			/>
		</MapContainer>
	)
}

const BranchSwitcher = () => {
	const [isActive, setIsActive] = useState(false)
	const WrapperRef = useRef()
	// eslint-disable-next-line no-unused-vars
	const [modalOpen, setModalOpen] = useState(false)
	const { mapCurrentStateText } = useGlobals()
	const { container } = useNavigatorContext()
	const direction = useScrollDirection()

	useGSAP(
		() => {
			if (!container) return
			const enter = () => setIsActive(true)
			const leave = () => setIsActive(false)

			ScrollTrigger.create({
				endTrigger: container,
				pin: WrapperRef.current,
				start: "top top",
				end: "bottom bottom",
				// markers: true,
				pinSpacing: false,
				onEnter: enter,
				onEnterBack: enter,
				onLeave: leave,
				onLeaveBack: leave,
				invalidateOnRefresh: true,
			})
		},
		{
			dependencies: [container],
			revertOnUpdate: true,
		},
	)
	return (
		<Wrapper ref={WrapperRef} className={`no-margin`}>
			<TranslateContainer className={`col-mobile-8 no-margin padding ${isActive && direction === "down" ? "shift" : ""}`}>
				<Container className="col-mobile-5">
					<Text>{mapCurrentStateText}</Text>
					<BranchSelect />
				</Container>
				<GMAP className="col-mobile-3" onClick={() => setModalOpen(true)} />
				{/*<Modal isOpen={modalOpen} handleClose={() => setModalOpen(false)}>*/}
				{/*	<GMAP/>*/}
				{/*</Modal>*/}
			</TranslateContainer>
		</Wrapper>
	)
}

export default BranchSwitcher
